class cancelController {
    constructor($state, $stateParams, $translate, $uibModal, cacheService, myBookingService) {
        'ngInject';
        this.name = 'cancel';
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.myBookingService = myBookingService;
        this.is_there_flash_message = false;
        this.disabled = false;
        let cancelResponse;
        this.cancelResponseMessage = {};
        this.cacheService = cacheService;
        this.TRANSFER_STATUS_ACTIVE = 'active';
        this.TRANSFER_STATUS_CANCELLED = 'cancelled';
        this.TRANSFER_STATUS_COMPLETED = 'completed';

        this.numActiveTransfers = this.getNumOfActiveTransfers();

        if (cancelResponse = cacheService.get('cancelResponse')) {
            this.showConfirmCancelMessage(cancelResponse.status, cancelResponse.message);
            this.is_there_flash_message = true;
            cacheService.delete('cancelResponse');
        }
    }

    $onInit() {
        this.translations = this.$translate.instant([
            "content_title_cancel",
            "msg_2",
            "no_credit_card_note",
            "button_cancel_booking",
            "button_cancel_transfer_n",
            "cancel_all_transfers_note",
            "cancel_note_transfer_1",
            "cancel_note_transfer_2",
            "sure_for_cancel_note",
            "less_than_24_note",
            "sure_cancel_booking_note",
            "less_than_24_booking_note",
            "yes_cancel_transfer_n",
            "no_cancel_transfer_n",
            "yes_cancel_all_transfers",
            "no_cancel_all_transfers",
            "booking_cancellation_json",
            "transfer_cancellation_json"
        ]);

        this.booking.translations.mainTitleKey = this.translations.content_title_cancel;
        if (this.cancel !== null) {
            this.cancel.transfers = this.addTransferFlags(this.cancel.transfers);
        }
    }

    // TODO move to a service
    addTransferFlags(transfers) {
        return transfers.map((transfer) => {
            transfer.flags = {
                isActive: transfer.status === this.TRANSFER_STATUS_ACTIVE
            };
            return transfer;
        });
    }

    cancelBooking() {
            this.disabled = true;
            this.myBookingService.postCancelBooking(this.$stateParams.bookingReference)
                .then(response => {
                    this.$state.reload();
                    this.cacheService.set('cancelResponse', {status: 'success', message: this.translations.booking_cancellation_json});
                })
                .catch(err => {
                    //TODO: add literal
                    this.disabled = false;
                    this.cacheService.set('cancelResponse', {status: 'error', message: 'Error Booking Message'});
                })
    }

    cancelTransfer(transfer) {
            this.disabled = true;
            this.myBookingService.postCancelTransfer(this.$stateParams.bookingReference, transfer.id)
                .then(response=> {
                    this.$state.reload();
                    this.cacheService.set('cancelResponse', {status: 'success', message: this.translations.transfer_cancellation_json});
                })
                .catch(err => {
                    //TODO: add literal
                    this.disabled = false;
                    this.cacheService.set('cancelResponse', {status: 'error', message: 'Error Transfer Message'});
                })
    }

    cancelPopup(title, message) {
        return this.openComponentModal({
            title: () => {
                return title;
            },
            message: () => {
                return message;
            }
        });
    }

    getCancelTransferConfirmationMessage(transfer) {
        return transfer.free_cancellation ? this.translations.sure_for_cancel_note : this.translations.less_than_24_note;
    }

    getCancelBookingConfirmationMessage() {

        const transfers = this.cancel.transfers;
        
        if (this.numActiveTransfers === 1) {
            return this.getCancelTransferConfirmationMessage(this.getActiveTransfer()[0]);
        }
        
        if (transfers[0].free_cancellation && transfers[1].free_cancellation) {
            return this.translations.sure_cancel_booking_note;
        }

        if (!transfers[0].free_cancellation && !transfers[1].free_cancellation) {
            return this.translations.less_than_24_booking_note;
        }

        if (!transfers[0].free_cancellation && transfers[1].free_cancellation) {
            let transfer_num_1 = this.$translate.instant('transfer_num', {
                num: 1
            });
            let transfer_num_2 = this.$translate.instant('transfer_num', {
                num: 2
            });
            return `
                ${transfer_num_1}:${this.getCancelTransferConfirmationMessage(transfers[0])}
                ${transfer_num_2}:${this.getCancelTransferConfirmationMessage(transfers[1])}
            `;
        }
    }

    canCancelAllBooking() {
        const transfers = this.cancel.transfers;
        if (this.isTransferOneCompleted(transfers)) {
            return false;
        }

        return this.areBothTransfersActive(transfers)
            || this.isAnyOfTheTransfersCancelledAndTheOtherActive(transfers)
            || this.thereIsOnlyTransferOneAndIsActive(transfers);
    }

    thereIsOnlyTransferOneAndIsActive(transfers) {
        return transfers.length === 1 && transfers[0].flags.isActive;
    }

    isAnyOfTheTransfersCancelledAndTheOtherActive(transfers) {
        return transfers.length === 2 && ((transfers[0].status === this.TRANSFER_STATUS_CANCELLED && transfers[1].flags.isActive)
            || (transfers[1].status === this.TRANSFER_STATUS_CANCELLED && transfers[0].flags.isActive));
    }

    isTransferOneCompleted(transfers) {
        return transfers[0].status === this.TRANSFER_STATUS_COMPLETED;
    }

    isTransferCancellable(index) {
        const transfers = this.cancel.transfers;

        return this.areBothTransfersActive(transfers) || this.isFirstTransferCompletedAndThisOneActive(transfers, index);
    }

    isFirstTransferCompletedAndThisOneActive(transfers, index) {
        return (transfers[0].status === this.TRANSFER_STATUS_COMPLETED) && (transfers[index].flags.isActive);
    }

    areBothTransfersActive(transfers) {
        return transfers.length === 2 && transfers[0].flags.isActive && transfers[1].flags.isActive;
    }

    openComponentModal(resolve) {
        let modalInstance = this.$uibModal.open({
            animation: false,
            component: 'stModal',
            resolve: resolve || {}
        });

        return modalInstance.result;
    }

    getNumOfActiveTransfers() {
        return this.getActiveTransfer().length;
    }

    getActiveTransfer() {
        if (this.cancel !== null) {
            return this.cancel.transfers.filter(item => item.status == this.TRANSFER_STATUS_ACTIVE);
        } else return [];
    }

    showConfirmCancelMessage($errorType, $cancelMessage){
        this.is_there_flash_message = true;
        document.body.scrollTop = 0;
        this.cancelResponseMessage = {
            status: $errorType,
            message: $cancelMessage
        };
    }

}

export default cancelController;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/cancel/cancel.controller.js